import NoPropertiesForm from '../NoPropertiesForm'

interface Props {
  item: SectionItem | FileItem
  mutate: (data: FolderItemConfig) => void
}

const SectionPropertiesForm = ({ item, mutate }: Props) => {
  return (
    <NoPropertiesForm
      item={item}
      // @ts-expect-error
      mutate={mutate}
    />
  )
}

export default SectionPropertiesForm
